import axios from '../lib/axios'

// Use the pre-configured axios instance
export const api = axios

// API endpoints
export const endpoints = {
  problems: {
    list: '/problem_list',
    get: (id: string) => `/problems/${id}`,
    submit: '/submissions',
    getSubmission: (token: string) => `/submissions/${token}`,
  },
  leaderboard: {
    get: '/get_leaderboard',
  },
  auth: {
    getApiKey: '/get_api_key',
  },
} as const 